module.exports = __webpack_public_path__ + "img/Capsella_rubella.1e31dcf0.jpg";